import { render, staticRenderFns } from "./tuanti.vue?vue&type=template&id=769ea45e&scoped=true"
import script from "./tuanti.vue?vue&type=script&lang=js"
export * from "./tuanti.vue?vue&type=script&lang=js"
import style0 from "./tuanti.vue?vue&type=style&index=0&id=769ea45e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769ea45e",
  null
  
)

export default component.exports